import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { getHreflangByI18nKey } from 'components/DocumentHead/helpers'
import { getCanonicalFromHreflangs } from 'helpers/seo'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import { inject } from 'mobx-react'
import * as R from 'ramda'
import React, { FC } from 'react'
import { IStoreProvider } from 'store'

const DocumentHead: FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackContentPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default R.compose(
  inject((store: IStoreProvider) => {
    const { originByLocaleMap, translatedUrlsPerLocale } = store.urlManagerStore
    const { locale } = store.localeStore
    const hasDroppedSubDomain = store.tadaridaFeatureStore.hasDroppedSubDomain

    const links = getHreflangByI18nKey({
      key: 'dein-shop_url',
      originByLocaleMap,
      translatedUrlsPerLocale,
      excludeLocales: store.featureStore.getDisabledExpansionLocales(),
    })
    const canonicalUrl = getCanonicalFromHreflangs({ hreflangs: links, locale })
    return {
      renderHreflangs: true,
      links,
      canonicalUrl,
      hasDroppedSubDomain,
    }
  }),
)(DocumentHead)
